import axios from "axios";

let PRIVATE_API_URL;

if (window.location.href.indexOf("bs-local") > -1) {
  PRIVATE_API_URL = "https://bs-local.com:8131";
} 
else if (window.location.href.indexOf("localhost") > -1 && window.location.href.indexOf("lambdatest") > -1) {
  PRIVATE_API_URL = "https://localhost.lambdatest.com:8131";
  // PRIVATE_API_URL = "https://dev.duon-portal.de";
} 
else if (window.location.href.indexOf("localhost") > -1) {
  PRIVATE_API_URL = "https://localhost:8131";
}
else if (window.location.href.indexOf("dev.duon-portal.de") > -1) {
  PRIVATE_API_URL = "https://dev.duon-portal.de";
} else if (window.location.href.indexOf("staging.duon-portal.de") > -1) {
  PRIVATE_API_URL = "https://staging.duon-portal.de";
} else if (
  window.location.href.indexOf("ui-duon-staging.azurewebsites.net") > -1
) {
  PRIVATE_API_URL = "https://ui-duon-staging.azurewebsites.net";
} else if (window.location.href.indexOf("ui-duon.azurewebsites.net") > -1) {
  PRIVATE_API_URL = "https://ui-duon.azurewebsites.net";
} else {
  PRIVATE_API_URL = "https://duon-portal.de";
}

const instance = axios.create({
  baseURL: PRIVATE_API_URL ? PRIVATE_API_URL : null
});

instance.interceptors.request.use(
  function(config) {
    // Do something before request is sent

    const token = localStorage.getItem("token");
    if (token) {
      instance.defaults.headers.common["Authorization"] = "Bearer " + token;
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default instance;
